const getProductBlockDisplayDetails = ({ product, variant }) => {
  if (product.productType === "Contact-lenses") {
    return {
      heading: product.name.localized,
      caption: variant.replacementFrequency || ""
    };
  }
  if (product.productType === "Solutions") {
    return {
      heading: product.name.localized,
      caption: `${variant.contactLensCareType || ""} ${variant.packageOption || ""}`
    };
  }
  return {
    heading: variant.brand.name,
    caption: variant.name.replace(variant.brand.name, "")
  };
};
export {
  getProductBlockDisplayDetails
};
//# sourceMappingURL=get-product-block-display-details.js.map
